/**
 *
 * WidgetOutcome
 *
 */

import React, { Fragment } from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Popover, Divider } from "antd"
import "./index.less"
import { get } from "lodash"
import { isAmbassadorActive, isModuleBySlug } from "../../utils/storage"
import { BENCHMARK, HISTORICAL_ANALYSIS } from "../../utils/constants"
import PopoverBenchmark from "../../Reports/components/PopoverBenchmark"
import { ArrowDownIcon } from "../../icons/svg/iconArrowDown"
import { ArrowUpIcon } from "../../icons/svg/iconArrowUp"
import DOMPurify from "dompurify"
/* eslint-disable react/prefer-stateless-function */
class WidgetOutcome extends React.Component {
  renderContent = (element) => {
    const sanitizedHTML = DOMPurify.sanitize(element.dimension_description || element.dimension_name);
    return (
      <div className="WidgetOutcome-body-item-content">
        <div className="WidgetOutcome-body-item-content-title">
          <Popover
            content={
              <div style={{ maxWidth: 350, textAlign: "justify" }}>
                <span
                  dangerouslySetInnerHTML={{
                    __html: sanitizedHTML,
                  }}
                />
                <Divider
                  style={{
                    margin: "10px -16px",
                    textAlign: "justify",
                    width: "calc(100% + 32px)",
                  }}
                />
                {element.metrics_questions &&
                  element.metrics_questions.length > 0 && (
                    <Fragment>
                      <b style={{ color: "#878787" }}>Pregunta:</b>
                      <br />
                      {element.metrics_questions.map((item, indexItem) => (
                        <Fragment key={indexItem}>
                          {item.name} <br />
                        </Fragment>
                      ))}
                    </Fragment>
                  )}
              </div>
            }>
            <span>{element.name}</span>
          </Popover>
        </div>
        <div
          className="WidgetOutcome-body-item-content-content"
          style={{ backgroundColor: element.color }}>
          <span
            className="WidgetOutcome-body-item-content-content-left"
            style={{ color: "#FFFFFF" }}>
            {element.value_visible}
          </span>
        </div>
      </div>
    )
  }

  renderBenchmark = (benchmark) => {
    const isBenchmark = isModuleBySlug(BENCHMARK)
    if (!benchmark.show || !isBenchmark) {
      return null
    }
    const { measureGeneral } = this.props
    if (!measureGeneral.ambassador_benchmark_visible && isAmbassadorActive()) {
      return null
    }
    return (
      <div className="WidgetOutcome-body-item-footer-benchmark">
        <div className="WidgetOutcome-body-item-footer-benchmark-title">
          <PopoverBenchmark
            isGlobalBenchmark={measureGeneral.is_global_benchmark}
          />
        </div>
        <div className="WidgetOutcome-body-item-footer-benchmark-content">
          <div className="WidgetOutcome-body-item-footer-benchmark-content-value">
            {benchmark.value}
          </div>
          <div
            className={`WidgetOutcome-body-item-footer-benchmark-content-compare ${
              benchmark.level
                ? " green"
                : benchmark.level === false
                ? " red"
                : ""
            }`}>
            <div
              style={{
                color: benchmark.level
                  ? " #55C8AE"
                  : benchmark.level === false
                  ? "#E37879"
                  : "",
              }}>
              {`${benchmark.variation}%`}
            </div>
            {benchmark.level > 0 ? (
              <ArrowUpIcon style={{ marginLeft: 2 }} />
            ) : benchmark.level === false ? (
              <ArrowDownIcon style={{ marginLeft: 2 }} />
            ) : null}
          </div>
        </div>
      </div>
    )
  }

  renderComparative = (calculate_comparative) => {
    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)
    if (!calculate_comparative.show || !isHistoricalAnalysis) {
      return null
    }
    return (
      <div
        className="WidgetOutcome-body-item-footer-previous"
        style={{
          marginRight: calculate_comparative.is_benchmark ? "16px" : "0px",
        }}>
        <div className="WidgetOutcome-body-item-footer-previous-title">
          Medición anterior
        </div>
        <div className="WidgetOutcome-body-item-footer-previous-content">
          <div className="WidgetOutcome-body-item-footer-previous-content-value">
            {calculate_comparative.prev_value}
            {"%"}
          </div>
          <div
            className={`WidgetOutcome-body-item-footer-previous-content-compare ${
              calculate_comparative.level ? " green" : " red"
            }`}>
            <div
              style={{
                color: calculate_comparative.level
                  ? " #55C8AE"
                  : calculate_comparative.level === false
                  ? "#E37879"
                  : "",
              }}>
              {calculate_comparative.value}
            </div>
            {calculate_comparative.level > 0 ? (
              <ArrowUpIcon style={{ marginLeft: 2 }} />
            ) : calculate_comparative.level === false ? (
              <ArrowDownIcon style={{ marginLeft: 2 }} />
            ) : null}
          </div>
        </div>
      </div>
    )
  }

  renderFooter = (element) => {
    const { calculate_comparative = {}, benchmark = {} } = { ...element }
    const isBenchmark = isModuleBySlug(BENCHMARK)
    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)
    const { measureGeneral } = this.props
    if (
      (!calculate_comparative.show || !isHistoricalAnalysis) &&
      (!benchmark.show ||
        !isBenchmark ||
        (!measureGeneral.ambassador_benchmark_visible && isAmbassadorActive()))
    ) {
      return null
    }
    calculate_comparative.is_benchmark = !(
      !benchmark.show ||
      !isBenchmark ||
      (!measureGeneral.ambassador_benchmark_visible && isAmbassadorActive())
    )
    return (
      <div className="WidgetOutcome-body-item-footer">
        {this.renderComparative(calculate_comparative)}
        {this.renderBenchmark(benchmark)}
      </div>
    )
  }

  render() {
    let { data, showTitle } = this.props
    data = data || []

    return (
      <Fragment>
        {showTitle && (
          <div className="subtitle_section color-black">Outcomes</div>
        )}

        <div className="WidgetOutcome-body">
          {data.map((element, index) => {
            return (
              <div
                key={index}
                className="WidgetOutcome-body-item"
                style={{
                  backgroundColor: "#FFFFFF",
                  height: data.length === 1 ? 66 : "auto",
                }}>
                {this.renderContent(element)}
                {this.renderFooter(element)}
              </div>
            )
          })}
        </div>
      </Fragment>
    )
  }
}

WidgetOutcome.propTypes = {}

export default WidgetOutcome
